//import Vue from "vue";
import VueRouter from 'vue-router'
import ComingSoon from "../views/ComingSoon.vue"
import MenuItem from "../views/Inventory/ItemMenuNew"
import MainLanding from "../views/MainLanding"
import SignIn from "../views/SignIn"
import ClubDetails from "../views/Inventory/ClubDetails"
import ClubStyle from "../views/Inventory/ThemeEditor"
import LiveOrders from "../views/BarActions/LiveOrders.vue"
import OrderHistory from "../views/BarActions/OrderHistory.vue"
import BarCreation from "../views/Inventory/BarCreation.vue"
import TableCreation from "../views/Inventory/TableCreation.vue"
import BathroomCreation from "../views/Inventory/BathroomCreation.vue"
import VenueList from "../views/Inventory/VenueList.vue"
import GenerateBarcode from "../views/BarActions/GenerateBarcode.vue"
import LoginScreen from "../views/LoginScreen.vue"
import ForgotPassword from "../views/ForgotPassword.vue"
import SignUp from "../views/SignUp.vue"
import ResetPassword from "../views/ResetPassword.vue"
import Instructions from "../views/Instructions.vue"
import Accounts from "../views/Login/Accounts.vue"
import AccountsStripeCallback from "../views/Login/AccountsStripeCallback.vue"
import EmployeeCode from "../views/EmployeeCode.vue"
import AboutMe from "../views/Informational/AboutMe.vue"
import PricingPage from "../views/Informational/PricingPage.vue"
import PrivacyPolicy from "../views/Informational/PrivacyPolicy.vue"
import TermsOfService from "../views/Informational/TermsOfService.vue"
import StageCreation from "../views/Inventory/StageCreation"
import PerformerPreview from "../views/Inventory/PerformerPreview.vue"
import PerformerDone from "../views/Inventory/PerformerDone.vue"
import PerformerList from "../views/Inventory/PerformerList.vue"







//Vue.use(Router, NProgress);

var  routes= [
  {
    name: "Main-Landing",
    path: "/",
    component: MainLanding,
    props: { default: true, reload: false }
  },
  {
    name: "stripe-redirect",
    path: "/stripe-redirect",
    component: MainLanding,
    props: { default: true, reload: false }
  },
  {
    name: "Login",
    path: "/Login",
    component: LoginScreen,
    props:true
  },
  {
    name: "PricingPage",
    path: "/PricingPage",
    component: PricingPage
  },
  {
    name: "PrivacyPolicy",
    path: "/PrivacyPolicy",
    component: PrivacyPolicy
  },
  {
    name: "TermsOfService",
    path: "/TermsOfService",
    component: TermsOfService
  },
  {
    name: "About",
    path: "/About",
    component: AboutMe,
  },
  {
    name: "Accounts",
    path: "/Accounts",
    component: Accounts,
    props:true,
    beforeEnter: (to, from, next) => {
      sessionStorage.getItem('token')!==null ? next() : next('/')
    }
  },
  {
  name: "StripeCallback",
  path: "/Accounts/stripe-callback",
  component: AccountsStripeCallback, // new component you’ll create
  props: true,
  beforeEnter: (to, from, next) => {
    sessionStorage.getItem('token') !== null ? next() : next('/');
  }
},
  {
    name: "EmployeeCode",
    path: "/EmployeeCode",
    component: EmployeeCode,
    beforeEnter: (to, from, next) => {
      sessionStorage.getItem('token')!==null ? next() : next('/')
    }
  },
  {
    name: "Forgot-Password",
    path: "/Forgot-Password",
    component: ForgotPassword,
    
  },
  {
    name: "Instructions",
    path: "/Instructions",
    component: Instructions,
    beforeEnter: (to, from, next) => {
      sessionStorage.getItem('token')!==null ? next() : next('/')
    }
  },
  {
    name: "Reset-Password",
    path: "/Reset-Password/:resetToken",
    component: ResetPassword,
  },
  {
    name: "Generate-QR",
    path: "/Generate-QR",
    component: GenerateBarcode,
    beforeEnter: (to, from, next) => {
      sessionStorage.getItem('token')!==null ? next() : next('/')
    }
  },
  {
    name: "Venue-List",
    path: "/Venue-List/",
    component: VenueList,
    props: true,
    beforeEnter: (to, from, next) => {
      sessionStorage.getItem('token')!==null ? next() : next('/')
    }
  },
  
  {
    name: "Bathroom-Creation",
    path: "/Bathroom-Creation/",
    component: BathroomCreation,
    beforeEnter: (to, from, next) => {
      sessionStorage.getItem('token')!==null ? next() : next('/')
    }
  },
  {
    name: "Bar-Creation",
    path: "/Bar-Creation/",
    component: BarCreation,
    beforeEnter: (to, from, next) => {
      sessionStorage.getItem('token')!==null ? next() : next('/')
    }
  },
  {
    name: "Table-Creation",
    path: "/Table-Creation/",
    component: TableCreation,
    beforeEnter: (to, from, next) => {
      sessionStorage.getItem('token')!==null ? next() : next('/')
    }
  },
  {
    name: "Live-Orders",
    path: "/Live-Orders",
    component: LiveOrders,
    beforeEnter: (to, from, next) => {
      sessionStorage.getItem('token')!==null ? next() : next('/')
    }
  },
  {
    name: "Order-History",
    path: "/Order-History",
    component: OrderHistory,
    beforeEnter: (to, from, next) => {
      sessionStorage.getItem('token')!==null ? next() : next('/')
    }
  },

  
  {
    name: "Club-Details",
    path: "/Club-Details",
    component: ClubDetails,
    props: true,
    beforeEnter: (to, from, next) => {
      sessionStorage.getItem('token')!==null ? next() : next('/')
    }
  },
  {
    name: "Style",
    path: "/Style",
    component: ClubStyle,
    props: true,
    beforeEnter: (to, from, next) => {
      sessionStorage.getItem('token')!==null ? next() : next('/')
    }
  },
  {
    name: "Sign-In",
    path: "/Sign-In",
    component: SignIn,
  },
  {
    name: "coming-soon",
    path: "/Coming-Soon",
    component: ComingSoon,
  },
  {
    name: "Menu",
    path: "/Menu",
    meta: { VIP: false },
    component: MenuItem,
    beforeEnter: (to, from, next) => {
      sessionStorage.getItem('token')!==null ? next() : next('/')
    }
  },
  {
    name: "VIP",
    path: "/VIP",
    meta: { VIP: true },
    component: MenuItem,
    beforeEnter: (to, from, next) => {
      sessionStorage.getItem('token')!==null ? next() : next('/')
    }
  },
  {
    name: "SignUp",
    path: "/SignUp",
    component: SignUp
  },
  {
    name: "Stage-Creation",
    path: "/Stage-Creation",
    component: StageCreation
  },
  {
    name: "Performer-Done",
    path: "/Performer-Done",
    component: PerformerDone,
  },
  {
    name: "Performer-Preview",
    path: "/Performer-Preview",
    component: PerformerPreview,
    props: route => {
    try {
      return { performer: JSON.parse(route.query.data || '{}') }
    } catch (e) {
      return { performer: {} }
    }
  }
  },
  {
    name: "Performer-List",
    path: "/Performer-List",
    component: PerformerList,
    props: route => {
    try {
      return { stage_ID: route.query.stage_ID, stageName:  route.query.stageName }
    } catch (e) {
      return { performer: {} }
    }
  }
  },
  {
    path: "/open",
    name: "OpenApp",
    component: () => import("@/views/Login/OpenMobile.vue"), // New page to handle redirection
  },
   {
    path: "/Performer",
    name: "PerformerForm",
    component: () => import("@/views/Inventory/PerformerForm.vue"), // New page to handle redirection
    props: route => {
    try {
      return { performer: JSON.parse(route.query.data || '{}') }
    } catch (e) {
      return { performer: {} }
    }
  }
  },

]

const router = new VueRouter({
  routes, // short for `routes: routes`
  mode:'history'
})
/*
//router.use(NProgress)
router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
 
  if (to.name) {
    // Start the route progress bar.

    try{
      this.$loading.show();
    }
    catch{
      // eslint-disable-next-line no-console
      console.log("Error occcured");  
    }
  
  }
  next();
});*/


export default router;
